window.$ = require("jquery");
const lang = document.querySelector("html").getAttribute("lang");

// https://flatpickr.js.org/
const flatpickr = require("flatpickr");
switch (lang) {
  case "az":
    flatpickr.default.localize(require("flatpickr/dist/l10n/az").default.az);
    break;
  case "ru":
    flatpickr.default.localize(require("flatpickr/dist/l10n/ru").default.ru);
    break;
}

// //https://datatables.net/
// import DataTable from "datatables.net-bs5";
// import "datatables.net-fixedcolumns-bs5";
// import "datatables.net-fixedheader-bs5";
// import "datatables.net-responsive-bs5";
// import "datatables.net-rowreorder-bs5";

//https://select2.org/
window.select2 = require("select2");
require("select2/dist/js/i18n/az");
$.fn.select2.defaults.set("theme", "bootstrap-5");
$.fn.select2.defaults.set("language", "az");
$.fn.select2.defaults.set("placeholder", {
  id: "",
  text: "Birini seçin",
});
$.fn.select2.defaults.set("allowClear", true);

//https://sweetalert2.github.io/
import Swal from "sweetalert2";

//https://github.com/js-cookie/js-cookie
// import Cookies from "js-cookie";

//https://robinherbots.github.io/Inputmask/#/documentation
// import Inputmask from "inputmask";

//https://clipboardjs.com/
import ClipboardJS from "clipboard";

// DataTable, Inputmask, Cookies,
export { Swal, ClipboardJS };
